import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class FinancialStatementUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);

    this.component.initializePage(id);
  }
}

export default new FinancialStatementUpdateWillMount();
